import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Nav } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import {
  GoogleMap,
  RequestLoading,
  RequestResult,
} from '../../../../components';
import { useAxiosQuery, useConfirmModal } from '../../../../hooks';
import Constants from '../../../../constants';
import { Routes as AppRoutes } from '../../../../router/routeMapping';

function formatPrice(price) {
  if (price >= 1000000) {
    return `${(price / 1000000).toFixed(2)}M`;
  }
  if (price >= 1000) {
    return `${(price / 1000).toFixed(0)}K`;
  }
  return price.toString();
}

function getScoreColor(score) {
  if (score >= 0 && score <= 39) {
    return 'Danger';
  }
  if (score >= 40 && score <= 59) {
    return 'Warning';
  }
  if (score >= 60 && score <= 79) {
    return 'Primary';
  }
  return 'Success';
}

const getMapPin = (type, text) => {
  let svgString = '';
  let width = 48;
  let height = 48;

  switch (type) {
    case 'Bus':
      svgString = `<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 256 256" id="BusStationLocation"><polygon fill="none" points="0 0 85 0 85 85 0 85"></polygon><path fill="#404040" d="M31 37l24 0c2,0 2,3 0,3l-24 0c-2,0 -2,-3 0,-3z" class="color427db7 svgShape"></path><path fill="#334349" d="M52 30c1 0 2 1 2 2 0 0-1 1-2 1-1 0-2-1-2-1 0-1 1-2 2-2zm-18 0l0 0c1 0 2 1 2 2 0 0-1 1-2 1-1 0-2-1-2-1 0-1 1-2 2-2zm6 1l0 0 6 0c0 0 0 1 0 1 0 0 0 0 0 0l-6 0c0 0 0 0 0 0 0 0 0-1 0-1zm0 3l0 0 6 0c0 0 0 0 0 0 0 0 0 1 0 1l-6 0c0 0 0-1 0-1 0 0 0 0 0 0zm0-5l0 0 6 0c0 0 0 1 0 1 0 0 0 0 0 0l-6 0c0 0 0 0 0 0 0 0 0-1 0-1zm-7-1l0 0 3 0c1 0 2 0 2-1l0-1c0 0 0-1 1-1l8 0c1 0 1 1 1 1l0 1c0 1 1 1 2 1l3 0c1 0 2 1 2 2l0 5c0 1 0 1-1 1l-22 0c-1 0-1 0-1-1l0-5c0-1 1-2 2-2zM50 41l3 0c0 0 1 0 1 0l0 3c0 0-1 0-1 0l-2 0c-1 0-2 0-2 0l0-3c0 0 1 0 1 0zm-17 0l0 0 3 0c0 0 0 0 0 0l0 3c0 0 0 0-1 0l-2 0c0 0-1 0-1 0l0-3c0 0 1 0 1 0z" class="color3a3b53 svgShape"></path><path fill="#334349" d="M41 16l4 0c0,0 0,2 0,2l-4 0c0,0 0,-2 0,-2zm-5 -1l0 0 14 0c1,0 3,1 3,3l0 9c0,1 0,1 0,1 0,0 0,0 0,0 0,0 -1,0 -1,0l-1 0c0,0 0,0 0,-1l0 -6c0,-1 0,-2 -1,-2l-5 0c-1,0 -1,1 -1,2l0 3 -2 0 0 -3c0,-1 0,-2 -1,-2l-5 0c-1,0 -1,1 -1,2l0 6c0,1 0,1 0,1l-1 0c-1,0 -1,0 -1,0 0,0 0,0 0,0 0,0 0,0 0,-1l0 -9c0,-2 2,-3 3,-3z" class="color3a3b53 svgShape"></path><path fill="#404040" fill-rule="nonzero" d="M32 21l-1 0c0 0 0 0 0 0l0 0 0-1c0 0 0 0 0-1 0 0 1 0 1 0l0 0c0 0 0 0 0 0l0 0c0-1 0-1 0-1l0 0c-1 0-1 1-1 1-1 0-1 1-1 1l0 1 0 0c0 0 0 0 0 0-1 0-1 0-1 0l0 0 0 3 0 0c0 1 1 1 1 1l2 0c0 0 0 0 0-1l0-3c0 0 0 0 0 0zM56 21c0 0 0 0 0 0l0 0 0-1c0 0 0-1-1-1 0 0-1-1-1-1l0 0c0 0 0 0 0 1l0 0c0 0 0 0 0 0l0 0c0 0 1 0 1 0 0 1 0 1 0 1l0 1 0 0c0 0 0 0 0 0l-1 0c0 0 0 0 0 0l0 3c0 1 0 1 0 1l2 0c0 0 1 0 1-1l0 0 0-3 0 0c0 0-1 0-1 0z" class="color427db7 svgShape"></path><path fill="#404040" d="M69 48l-24 36c0,1 -1,1 -2,1 -1,0 -2,0 -2,-1l-24 -36c-3,-5 -4,-10 -4,-17 0,-17 13,-31 30,-31 17,0 30,14 30,31 0,7 -1,12 -4,17zm-26 -41l0 0c-12,0 -22,11 -22,24 0,12 10,23 22,23 13,0 23,-11 23,-23 0,-13 -10,-24 -23,-24z" class="color427db7 svgShape"></path></svg>`;
      break;
    case 'own':
      width = 64;
      height = 48;
      svgString = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path fill="#377dff" d="M0,46.4V4.8C0,2.2,2.7,0,6,0h52c3.3,0,6,2.2,6,4.8v25.6c0,2.6-2.7,4.8-6,4.8H18.8L3.4,47.5
       C2.2,48.5,0,47.8,0,46.4z"/>
     <text x="52%" y="40%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" style="font-family:Arial; font-weight:bold;">${text}</text>
     </svg>
     `;
      break;
    case 'comp':
      width = 64;
      height = 48;
      svgString = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path fill="#00985A" d="M0,46.4V4.8C0,2.2,2.7,0,6,0h52c3.3,0,6,2.2,6,4.8v25.6c0,2.6-2.7,4.8-6,4.8H18.8L3.4,47.5
     C2.2,48.5,0,47.8,0,46.4z"/>
   <text x="52%" y="40%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" style="font-family:Arial; font-weight:bold;">${text}</text>
   </svg>
   `;
      break;

    case 'score':
      {
        const color = Constants.Colors.Theme[getScoreColor(text)];
        width = 64;
        height = 48;
        svgString = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path fill="${color}" d="M0,46.4V4.8C0,2.2,2.7,0,6,0h52c3.3,0,6,2.2,6,4.8v25.6c0,2.6-2.7,4.8-6,4.8H18.8L3.4,47.5
     C2.2,48.5,0,47.8,0,46.4z"/>
   <text x="52%" y="40%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" style="font-family:Arial; font-weight:bold;">${text}</text>
   </svg>
   `;
      }

      break;

    case 'Bus1':
      {
        const color = '#ff0000';
        const textColor = '#ffffff';
        width = 256;
        height = 48;
        svgString = `<svg width="256" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M24.0233 41.1847C20.6947 38.3378 10 28.5994 10 21C10 12 16 6 25 6C34 6 40 13.5 40 21C40 27.3634 29.2018 38.0462 25.929 41.1378C25.3952 41.6421 24.5813 41.662 24.0233 41.1847ZM30 19C30 21.7614 27.7614 24 25 24C22.2386 24 20 21.7614 20 19C20 16.2386 22.2386 14 25 14C27.7614 14 30 16.2386 30 19Z"
    fill="${color}"
  />
  ${
    text
      ? `<text x="52%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="${textColor}" style="font-family:Arial; font-weight:bold;">${text}</text>`
      : ''
  }
</svg>`;
      }

      break;

    default:
      {
        const color = Constants.Colors.Theme.Primary;
        const textColor = '#ffffff';
        width = 48;
        height = 48;
        svgString = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M24.0233 41.1847C20.6947 38.3378 10 28.5994 10 21C10 12 16 6 25 6C34 6 40 13.5 40 21C40 27.3634 29.2018 38.0462 25.929 41.1378C25.3952 41.6421 24.5813 41.662 24.0233 41.1847ZM30 19C30 21.7614 27.7614 24 25 24C22.2386 24 20 21.7614 20 19C20 16.2386 22.2386 14 25 14C27.7614 14 30 16.2386 30 19Z"
                      fill="${color}"
                    />
                    ${
                      text
                        ? `<text x="52%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="${textColor}" style="font-family:Arial; font-weight:bold;">${text}</text>`
                        : ''
                    }
                  </svg>`;
      }
      break;
  }

  return { svgString, width, height };
};

const mapTypes = [
  {
    titleKey: 'price',
  },
  {
    titleKey: 'score',
  },
];

function MapListingsByZip({ zip, height }) {
  const { confirm } = useConfirmModal({ confirmVariant: 'primary' });
  const [activeMapType, setActiveMapType] = useState(mapTypes[0].titleKey);

  const {
    data: apiData,
    isLoading: apiLoading,
    error: apiError,
  } = useAxiosQuery({
    url: '/homes/list',
    preventFetch: !zip,
    params: {
      zipCode: zip,
      status: 'ACTIVE',
      quantity: 999999,
    },
  });

  const markerOnClick = async ({ item }) => {
    if (!item.id) {
      return;
    }
    const isSuccess = await confirm({
      title: 'Listing Overview',
      message: <FormattedMessage id="app.common.compDialogMessage" />,
      confirmLabel: 'Yes',
    });

    if (isSuccess) {
      window.open(
        `${AppRoutes.protected.LISTINGS_DETAIL.path.replace(':id', item.id)}`,
        '_blank'
      );
    }
  };

  return (
    <Card className="h-100">
      <Card.Header className="card-header-content-between">
        <Card.Title bsPrefix="card-header-title" as="h4">
          <FormattedMessage id="app.common.zipMapAnalysis" />
        </Card.Title>
        {!apiLoading && !apiError && apiData?.length > 0 && (
          <Nav
            variant="segment"
            fill
            as="ul"
            activeKey={activeMapType}
            onSelect={setActiveMapType}
          >
            {mapTypes.map(({ titleKey }) => (
              <Nav.Item key={titleKey} as="li">
                <Nav.Link eventKey={titleKey}>
                  <FormattedMessage id={`app.common.${titleKey}`} />
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        )}
      </Card.Header>
      <div>
        <RequestLoading loading={apiLoading} margin="5" />
        <RequestResult type="error" message={apiError} />
        {!apiLoading && !apiError && apiData?.length === 0 && (
          <RequestResult
            type="secondary"
            message="app.common.noListings"
            image
          />
        )}
        {!apiLoading && !apiError && apiData?.length > 0 && (
          <div>
            {activeMapType === mapTypes[0].titleKey ? (
              <GoogleMap
                className="rounded-bottom"
                height={height}
                initialZoom={14}
                initialMarks={[
                  /* {
                lat: Number(apiData.rows[0].latitude),
                lng: Number(apiData.rows[0].longitude),
                customIcon: getMapPin('own', formatPrice(apiData.rows[0].price)),
              }, */
                  ...apiData.map(({ latitude, longitude, ...rest }) => ({
                    lat: Number(latitude),
                    lng: Number(longitude),
                    customIcon: getMapPin('comp', formatPrice(rest.price)),
                    ...rest,
                  })),
                ]}
                initialCenter={{
                  lat: Number(apiData[0].latitude),
                  lng: Number(apiData[0].longitude),
                }}
                markerOnClick={markerOnClick}
              />
            ) : (
              <GoogleMap
                height={height}
                initialZoom={14}
                initialMarks={[
                  /* {
                lat: Number(apiData.rows[0].latitude),
                lng: Number(apiData.rows[0].longitude),
                customIcon: getMapPin('own', formatPrice(apiData.rows[0].price)),
              }, */
                  ...apiData.map(({ latitude, longitude, ...rest }) => ({
                    lat: Number(latitude),
                    lng: Number(longitude),
                    customIcon: getMapPin('score', Math.round(rest.AIRate)),
                    ...rest,
                  })),
                ]}
                initialCenter={{
                  lat: Number(apiData[0].latitude),
                  lng: Number(apiData[0].longitude),
                }}
                markerOnClick={markerOnClick}
              />
            )}
          </div>
        )}
      </div>
    </Card>
  );
}

MapListingsByZip.propTypes = {
  zip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  height: PropTypes.number,
};

MapListingsByZip.defaultProps = {
  height: 550,
};

export default MapListingsByZip;
